export const SEARCH_TYPE_VALUES = [
	'keywords',
	'prompt',
	'reference',
	'lyrics',
] as const
